import React from 'react';
import clsx from 'clsx';
import './Button.css';

const Button = ({ label, onClick, type="primary", className }) => {
  return <button className={clsx('Button', className, (type === 'secondary') && 'Secondary')} onClick={onClick}>
    {label}
  </button>;
}

export default Button;
